export const REDUCER_KEY_PROJECT_CREATION_DIALOG = 'projectCreateDialog';

export const CLEAN_OPTIONS = 'rs/projectCreateDialog/CLEAN_OPTIONS';
export const FETCH_OPTIONS = 'rs/projectCreateDialog/FETCH_OPTIONS';
export const FETCH_OPTIONS_SUCCESS = 'rs/projectCreateDialog/FETCH_OPTIONS_SUCCESS';
export const FETCH_OPTIONS_FAILURE = 'rs/projectCreateDialog/FETCH_OPTIONS_FAILURE';

export const SAVE_OPTIONS = 'rs/projectCreateDialog/SAVE_OPTIONS';
export const SAVE_OPTIONS_SUCCESS = 'rs/projectCreateDialog/SAVE_OPTIONS_SUCCESS';
export const SAVE_OPTIONS_FAILURE = 'rs/projectCreateDialog/SAVE_OPTIONS_FAILURE';

export const PREDICTED_PARAMS_SECTION_LABEL = 'Information on predictive retrosynthesis parameters settings.';
export const PREDICTED_PARAMS_NUMBER_OF_ROUTES_LABEL = 'Information on the maximum number of routes that can be generated.';
export const PREDICTED_PARAMS_DIVERSE_OF_ROUTES_LABEL = 'Information on how to set a more diverse list of routes.';
export const PREDICTED_PARAMS_PROCESSING_TIME_LABEL = 'Information on processing time limits.';
export const PREDICTED_PARAMS_MAX_PRICE_LABEL = 'Information on max. price per gram filter.';
export const PREDICTED_PARAMS_BBLIBS_LABEL = 'Information on building block libraries to be considered in the generation of routes.';
export const PUBLISHED_PARAMS_SECTION_LABEL = 'Information on published retrosynthesis parameters settings.';
export const PUBLISHED_PARAMS_NUMBER_OF_ROUTES_LABEL =
  'Information on the maximum number of routes that can be generated from published literature.';

export const PREDICTED_PARAMS_IKTOS_GENERAL = 'General';
export const PREDICTED_PARAMS_IKTOS_INTERMEDIATES = 'Intermediates';

export const IK_PARAMS_MAX_NUMBER_OF_ROUTES_INFO_LABEL = 'Information on the maximum number of routes that can be generated.';
export const IK_PARAMS_SELECTIVITY_INFO_LABEL = 'Information on selectivity.';
export const IK_PARAMS_SMS_INFO_LABEL = 'Information on starting materials settings to be considered in the generation of routes.';
export const IK_PARAMS_MAX_SHIPPING_TIME = 'Information on shipping times to be considered in the generation of routes.';

export const IK_PARAMS_SMILES_MAX_COUNT = 10;
export const IK_PARAMS_SMILES_INVALID_ERROR = 'The SMILES input is invalid.\n Please check the SMILES and try again.';
export const IK_PARAMS_SMILES_COUNT_ERROR = 'You can only enter up to 10 SMILES.\n Please modify your list and try again.';

export const RCS10D = 'RCS10D';
export const RCSANY = 'RCSANY';
export const RCSGT10D = 'RCS>10D';
export const RCS$10 = 'RCS$10';
export const RCS_LIBRARIES = [RCS10D, RCSANY, RCSGT10D, RCS$10];

export const maxShippingTimeDisplayHelperObj = {
  RCS10D: 'up to 10 days',
  RCSANY: 'any',
};
export const maxShippingTimeToggleHelperObj = {
  RCS10D: RCSANY,
  RCSANY: RCS10D,
};

export const RPS10D = 'RPS10D';
export const RPSANY = 'RPSANY';
export const RPS10D10U = 'RPS10D10U';
export const RPSANY10U = 'RPSANY10U';
export const RPS_LIBRARIES = [RPS10D, RPSANY, RPS10D10U, RPSANY10U];
